import { popoverNextLegacyDriverFactory } from '../../PopoverNext/PopoverNext.driver';
import { deprecationTestkitLog } from '../../utils/deprecationTestkitLog';

export const closablePopoverDriverFactory = ({ element, eventTrigger }) => {
  deprecationTestkitLog(
    'closablePopoverDriverFactory legacy testkit is deprecated and will be removed in next major release. Please use closablePopoverUniDriverFactory from ClosablePopover.uni.driver instead.',
  );

  const popoverDriver = popoverNextLegacyDriverFactory({
    element,
    eventTrigger,
  });

  return {
    ...popoverDriver,
    /** Checks if the popover's content is open */
    isOpened: () => popoverDriver.isContentElementExists(),
  };
};
